// Auto generated file, do not manually modify!
// com.hotpads.leasing.api.web.v1.generatedlease.GeneratedLeaseWebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import { GeneratedLeaseWebApiHandler_saveFeedback } from '@zg-rentals/ts-leasing-client';

import type { GeneratedLeaseFeedbackRequestDto } from '@zg-rentals/ts-leasing-client';

export interface GeneratedLeaseWebApiHandler_saveFeedback_Args {
  postData: GeneratedLeaseFeedbackRequestDto;
}

export type GeneratedLeaseWebApiHandler_saveFeedback_Options = UseMutationOptions<
  void,
  unknown,
  GeneratedLeaseWebApiHandler_saveFeedback_Args
>;

/**
 * save generated lease feedback for landlord
 */
export const useGeneratedLeaseWebApiHandler_saveFeedback = ({
  httpClient,
  ...options
}: Omit<GeneratedLeaseWebApiHandler_saveFeedback_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: GeneratedLeaseWebApiHandler_saveFeedback_Args) =>
      GeneratedLeaseWebApiHandler_saveFeedback(args.postData, httpClient),
  });
};
